import { LOGIN, LOGIN_FIREBASE } from '../query/User';
import {
  CANCEL_SURVEY_CAMPAIGN,
  CREATE_SURVEY_CAMPAIGN,
  RESEND_SURVEY_CAMPAIGN,
  SCHEDULE_SURVEY_CAMPAIGN,
  SEND_SURVEY_CAMPAIGN,
  SEND_SURVEY_CAMPAIGN_TEST,
  UPDATE_SURVEY_CAMPAIGN,
} from './SurveyCampaign';
import {
  CREATE_PROGRAM,
  UPDATE_PROGRAM,
  DELETE_PROGRAM,
  CREATE_PROGRAM_PRICING,
  UPDATE_PROGRAM_PRICES,
} from './VistageProgram';
import {
  CREATE_PROGRAM_CATEGORY,
  UPDATE_PROGRAM_CATEGORY,
  DELETE_PROGRAM_CATEGORY,
} from './VistageProgramCategory';
import {
  CREATE_PROGRAM_REGION,
  UPDATE_PROGRAM_REGION,
  DELETE_PROGRAM_REGION,
} from './VistageProgramRegion';
import {
  CREATE_PROGRAM_VARIANT,
  UPDATE_PROGRAM_VARIANT,
  DELETE_PROGRAM_VARIANT,
} from './ProgramVariant';
import {
  CREATE_TOPIC,
  UPDATE_TOPIC,
  DELETE_TOPIC,
} from './Topic';
import {
  CREATE_PRESENTATION,
  UPDATE_PRESENTATION,
  DELETE_PRESENTATION,
  SUBMIT_PRESENTATION,
  CANCEL_PRESENTATION,
  LOAD_PRESENTATION_RECEIPTS,
  ROLLBACK_PRESENTATION_BILLING,
  REGISTER_PRESENTATION_CLOSE,
  UPLOAD_PRESENTATION_EXPENSE_FILE,
  UPLOAD_PRESENTATION_INVOICE_FILE,
  UPLOAD_PRESENTATION_VIATICOS_FILE,
  SEND_PRESENTATION_INVOICE_DOCUMENTATION,
  CHANGE_PRESENTATION_STATUS,
} from './Presentation';
import {
  DELETE_USER,
  RESET_PASSWORD,
  SET_PASSWORD,
  UPDATE_USER,
  CREATE_USER,
  UPSERT_USER_ROLE,
  UPSERT_USER_FIREBASE,
  CREATE_PROFILE_PICTURE,
  UPDATE_PROFILE_PICTURE,
  DELETE_PROFILE_PICTURE,
  UPDATE_AUTH_DATA,
  COMPLETE_REGISTER,
  RESEND_VALIDATE_TOKEN,
  CREATE_USER_PUBLIC,
  UPDATE_LAST_TENANT_ID_SELECTED,
  FORCE_CHANGE_PASSWORD,
  FORCE_CHANGE_PASSWORD_BY_ADMIN,
  UNLINK_USER,
} from './User';
import { CREATE_COMPANY, UPDATE_COMPANY, DELETE_COMPANY } from './Company';
import { UPDATE_SETTING, UPDATE_SETTING_TRANSLATION } from './AppSetting';
import { CREATE_ROLE, DELETE_ROLE, UPDATE_ROLE } from './Role';
import { UPSERT_ROLE_PERMISSION } from './RolePermission';
import {
  CREATE_OPERATION,
  DELETE_OPERATION,
  UPDATE_IMPORTANT_OPERATION,
  UPDATE_OPERATION,
} from './Operation';
import { REFRESH_TOKEN } from './RefreshToken';
import { UPDATE_PERMISSION } from './Permission';
import {
  DISABLE_TWO_FACTOR_AUTH,
  GENERATE_TOTP_URL,
  TWO_FACTOR_AUTH,
} from './Totp2FA';
import { CREATE_SIGNATURE, DELETE_SIGNATURE } from './Signature';
import {
  CREATE_TENANT,
  CREATE_TENANT_PUBLIC,
  DELETE_TENANT,
  RESEND_EMAIL_CREATE_PUBLIC,
  UPDATE_TENANT,
} from './Tenant';
import { CREATE_TAG, DELETE_ENTITY_TAG } from './Tag';
import { CREATE_TAG_ENTITY } from './Tag';
import {
  ACTIVE_TERMS_AND_CONDITIONS,
  CREATE_TERMS_AND_CONDITIONS,
  ACCEPT_TERMS_AND_CONDITIONS,
} from './TermsAndConditions';
import { CREATE_LOGIN_METHOD, DELETE_LOGIN_METHOD } from './LoginMethod';
import {
  CREATE_INVITATION,
  INVITATION_RESPONSE,
  DELETE_INVITATION,
  RESEND_INVITATION,
} from './Invitation';
import { CREATE_TENANT_SETTING, UPDATE_TENANT_SETTING } from './TenantSetting';
import { CREATE_NOTE, DELETE_NOTE, UPDATE_NOTE } from './Note';
import {
  CANCEL_USER_PLAN,
  UPSERT_USER_PLAN,
  UPSERT_AUTHORIZED_USER_PLAN,
} from './UserPlan';
import { CREATE_CATEGORY, DELETE_CATEGORY, UPDATE_CATEGORY } from './Category';
import {
  CREATE_PRODUCT,
  DELETE_PRODUCT,
  SOLICIT_ADJUSTMENTS_OF_PRODUCT,
  SOLICIT_APPROVAL_OF_PRODUCT,
  SOLICIT_REJECT_OF_PRODUCT,
  SOLICIT_REVISION_OF_PRODUCT,
  TOGGLE_PRODUCT_SPECIFICATION_STATUS,
  TOGGLE_PRODUCT_STATUS,
  UPDATE_PRODUCT,
} from './Product';
import { CREATE_STOCK_MOVEMENT } from './StockMovement';
import {
  ASSIGN_SHOP_TO_TENANT,
  CREATE_SHOP,
  DELETE_SHOP,
  UPDATE_SHOP,
} from './Shop';
import {
  CANCEL_ORDER,
  CANCEL_TRACKING_CODE,
  CLOSE_INCIDENT,
  CLOSE_REVISION,
  CONFIRM_ORDER,
  DELETE_ORDER,
  DELETE_TICKET,
  DISPATCH_SCANNED_ORDER,
  GENERATE_TICKET,
  GENERATE_TRACKING_CODE,
  IMPORT_ORDER_PAYMENTS,
  LABEL_DELIVERED,
  LABEL_RETURNED,
  PREPARE_ORDER,
  PRINT_TICKET_ORDER,
  REGISTER_DISPATCH_ORDER,
  REGISTER_ORDER_INCIDENT,
  REGISTER_PAYMENT_ORDER,
  REJECT_ORDER,
  REQUEST_CANCELLATION,
  RESCUE_ORDER,
  RETURN_STOCK_ORDER,
  SOLICIT_REVISION_OF_ORDER,
  UPDATE_ORDER,
  UPDATE_ORDER_PAYMENT_STATUS,
  UPDATE_ORDER_PAYMENT_TYPE,
  UPDATE_ORDER_SHIPMENT_ADDRESS,
  UPDATE_ORDER_TOTAL,
} from './Order';
import {
  ADD_ORDER_LINE,
  DELETE_ORDER_LINE,
  UPDATE_ORDER_LINE,
} from './OrderLine';
import { CREATE_SUPPLIER, DELETE_SUPPLIER, UPDATE_SUPPLIER } from './Supplier';
import { CREATE_WALLET_MOVEMENT } from './WalletMovement';
import {
  CREATE_WALLET_REQUEST,
  DELETE_WALLET_REQUEST,
  UPDATE_WALLET_REQUEST,
} from './WalletRequest';
import { UPDATE_NOTIFICATION_STATUS } from './Notification';
import { CREATE_EVENT, UPDATE_EVENT, DELETE_EVENT } from './VistageEvent';
import { CREATE_VCG, UPDATE_VCG, DELETE_VCG } from './Vcg';
import {
  CREATE_TAX_CONDITION,
  UPDATE_TAX_CONDITION,
  DELETE_TAX_CONDITION,
} from './TaxCondition';
import {
  CREATE_USA_PROGRAM,
  UPDATE_USA_PROGRAM,
  DELETE_USA_PROGRAM,
} from './VistageUsaProgram';
import {
  CREATE_EXHIBITION_CATEGORY,
  UPDATE_EXHIBITION_CATEGORY,
  DELETE_EXHIBITION_CATEGORY,
} from './ExhibitionCategory';
import {
  CREATE_EXHIBITION_SUBCATEGORY,
  UPDATE_EXHIBITION_SUBCATEGORY,
  DELETE_EXHIBITION_SUBCATEGORY,
} from './ExhibitionSubcategory';
import {
  CREATE_HITO_TIPO,
  UPDATE_HITO_TIPO,
  DELETE_HITO_TIPO,
} from './HitoTipo';
import {
  CREATE_HITO_SUBTIPO,
  UPDATE_HITO_SUBTIPO,
  DELETE_HITO_SUBTIPO,
} from './HitoSubtipo';
import {
  CREATE_MEMBER_HITO,
  UPDATE_MEMBER_HITO,
  DELETE_MEMBER_HITO,
} from './MemberHito';
import { CREATE_CONTACT, UPDATE_CONTACT, DELETE_CONTACT } from './Contact';
import { CREATE_STAFF, UPDATE_STAFF, DELETE_STAFF } from './Staff';
import { CREATE_CHAIR, UPDATE_CHAIR, DELETE_CHAIR } from './Chair';
import {
  CREATE_PROSPECT,
  CREATE_PROSPECT_WITH_CONTACT,
  UPDATE_PROSPECT,
  DELETE_PROSPECT,
} from './Prospect';
import {
  REQUEST_PROSPECT_REASSIGNMENT,
  APPROVE_PROSPECT_REASSIGNMENT_AS_CHAIR,
  APPROVE_PROSPECT_REASSIGNMENT_AS_STAFF,
  REJECT_PROSPECT_REASSIGNMENT,
} from './ProspectReassignment';
import {
  CREATE_CONTACT_FOLLOW_UP_NOTE,
  CREATE_FOLLOW_UP_NOTE,
} from './ContactLog';
import {
  CREATE_ENTRY_FORM,
  EDIT_ENTRY_FORM,
  DELETE_ENTRY_FORM,
  REQUEST_ENTRY_FORMS,
  CANCEL_ENTRY_FORMS,
  APPROVE_ENTRY_FORM,
  FINALIZE_ENTRY_FORM,
  LOAD_ENTRY_FORM,
  CONFIRM_ENTRY_FORM,
  MARK_PROCESSED_ENTRY_FORM,
  CHANGE_ENTRY_FORM_STATUS,
  UPLOAD_ENTRY_FORM_SIGNATURE,
  UPLOAD_ENTRY_FORM_AUTHORIZATION,
  SAVE_ENTRY_FORM_DRAFT,
  SUBMIT_ENTRY_FORM,
  UPLOAD_ENTRY_FORM_SIGNATURE_BY_TOKEN,
} from './EntryForm';
import * as MEETING from './Meeting';
import { RESEND_EVALUATION_EMAIL, SUBMIT_EVALUATION, SUBMIT_MEETING_EVALUATION } from './Meeting';
import {
  CREATE_MEETING_GROUP,
  CREATE_MEETING_GROUPS,
  REMOVE_MEETING_GROUP,
  COMPLETE_MEETING_GROUPS,
  MARK_ATTENDANCE_LOADED,
} from './MeetingGroup';
import {
  CREATE_GROUP,
  UPDATE_GROUP,
  DELETE_GROUP,
  ASSIGN_CHAIR_TO_GROUP,
  UPDATE_GROUP_CHAIR_ASSIGNMENT,
  UPDATE_ALL_GROUPS_BUDGET,
} from './Group';
import {
  CREATE_EXHIBITOR,
  UPDATE_EXHIBITOR,
  DELETE_EXHIBITOR,
  UPDATE_MY_EXHIBITOR_PROFILE,
} from './Exhibitor';
import { CREATE_EXHIBITOR_REVIEW } from './ExhibitorReview';
import {
  INVITE_EXHIBITOR_BY_FORM,
  SUBMIT_EXHIBITOR_FORM,
  UPLOAD_EXHIBITOR_FORM_PROFILE_PICTURE,
} from './ExhibitorFormToken';
import {
  SUBMIT_EXTERNAL_PRESENTER_INVOICE_BY_TOKEN,
  UPDATE_EXTERNAL_PRESENTER_INVOICE_DATA,
  RESEND_EXTERNAL_PRESENTER_INVOICE_TOKEN,
} from './ExternalPresenterInvoice';
import { CREATE_MEMBER, UPDATE_MEMBER, DELETE_MEMBER, ADD_MEMBER_TO_HUMAND } from './Member';
import {
  CREATE_REQUEST,
  EDIT_PENDING_REQUEST,
  APPROVE_REQUEST,
  REJECT_REQUEST,
  CANCEL_REQUEST,
  LOGIC_DELETE_REQUEST,
  FINALIZE_REQUEST,
} from './Request';
import {
  CREATE_LEAVE_FORM,
  SUBMIT_LEAVE_FORM_BY_TOKEN,
} from './LeaveForm';
import { CREATE_LEAVE_FORM_CALL_ATTEMPT } from './LeaveFormCallAttempt';
import { APPLY_GROUP_MOVEMENT, REVERSE_GROUP_MOVEMENT } from './GroupMovement';
import { UPLOAD_GROUP_FILES, DELETE_GROUP_FILE } from './GroupFile';
import { REGISTER_BUDGET_MOVEMENT } from './GroupBudgetMovement';

const Mutation = {
  createCompany: { name: 'createCompany', gql: CREATE_COMPANY },
  createOperation: { name: 'createOperation', gql: CREATE_OPERATION },
  createRole: { name: 'createRole', gql: CREATE_ROLE },
  createUser: { name: 'createUser', gql: CREATE_USER },
  deleteCompany: { name: 'deleteCompany', gql: DELETE_COMPANY },
  deleteOperation: { name: 'deleteOperation', gql: DELETE_OPERATION },
  deleteRole: { name: 'deleteRole', gql: DELETE_ROLE },
  deleteUser: { name: 'deleteUser', gql: DELETE_USER },
  login: { name: 'login', gql: LOGIN },
  loginFirebase: { name: 'loginFirebase', gql: LOGIN_FIREBASE },
  resetPassword: { name: 'resetPassword', gql: RESET_PASSWORD },
  setPassword: { name: 'setPassword', gql: SET_PASSWORD },
  updateAppSetting: { name: 'updateAppSetting', gql: UPDATE_SETTING },
  updateAppSettingTranslation: {
    name: 'updateAppSettingTranslation',
    gql: UPDATE_SETTING_TRANSLATION,
  },
  updateCompany: { name: 'updateCompany', gql: UPDATE_COMPANY },
  updateOperation: { name: 'updateOperation', gql: UPDATE_OPERATION },
  updatePermission: { name: 'updatePermission', gql: UPDATE_PERMISSION },
  updateRole: { name: 'updateRole', gql: UPDATE_ROLE },
  updateUser: { name: 'updateUser', gql: UPDATE_USER },
  upsertUserRole: { name: 'upsertUserRole', gql: UPSERT_USER_ROLE },
  upsertRolePermission: {
    name: 'upsertRolePermission',
    gql: UPSERT_ROLE_PERMISSION,
  },
  createNote: { name: 'createNote', gql: CREATE_NOTE },
  updateNote: { name: 'updateNote', gql: UPDATE_NOTE },
  deleteNote: { name: 'deleteNote', gql: DELETE_NOTE },
  upsertUserPlan: { name: 'upsertUserPlan', gql: UPSERT_USER_PLAN },
  upsertAuthorizedUserPlan: {
    name: 'upsertUserPlan',
    gql: UPSERT_AUTHORIZED_USER_PLAN,
  },
  cancelUserPlan: { name: 'cancelUserPlan', gql: CANCEL_USER_PLAN },
  refreshToken: { name: 'refreshToken', gql: REFRESH_TOKEN },
  upsertUserFirebase: { name: 'upsertUserFirebase', gql: UPSERT_USER_FIREBASE },
  createProfilePicture: {
    name: 'createProfilePicture',
    gql: CREATE_PROFILE_PICTURE,
  },
  updateProfilePicture: {
    name: 'updateProfilePicture',
    gql: UPDATE_PROFILE_PICTURE,
  },
  deleteProfilePicture: {
    name: 'deleteProfilePicture',
    gql: DELETE_PROFILE_PICTURE,
  },
  updateAuthData: {
    name: 'updateAuthData',
    gql: UPDATE_AUTH_DATA,
  },
  disableTwoFactorAuth: {
    name: 'disableTwoFactorAuth',
    gql: DISABLE_TWO_FACTOR_AUTH,
  },
  generateTotpUrl: {
    name: 'generateTotpUrl',
    gql: GENERATE_TOTP_URL,
  },
  twoFactorAuth: {
    name: 'twoFactorAuth',
    gql: TWO_FACTOR_AUTH,
  },
  createSignature: {
    name: 'createSignature',
    gql: CREATE_SIGNATURE,
  },
  deleteSignature: {
    name: 'deleteSignature',
    gql: DELETE_SIGNATURE,
  },
  createTenant: {
    name: 'createTenant',
    gql: CREATE_TENANT,
  },
  deleteTenants: {
    name: 'deleteTenants',
    gql: DELETE_TENANT,
  },
  updateTenant: {
    name: 'updateTenant',
    gql: UPDATE_TENANT,
  },
  completeRegister: {
    name: 'completeRegister',
    gql: COMPLETE_REGISTER,
  },
  resendValidateToken: {
    name: 'resendValidateToken',
    gql: RESEND_VALIDATE_TOKEN,
  },
  createUserPublic: {
    name: 'createUserPublic',
    gql: CREATE_USER_PUBLIC,
  },
  createTag: {
    name: 'createTag',
    gql: CREATE_TAG,
  },
  createTagEntity: {
    name: 'createTagEntity',
    gql: CREATE_TAG_ENTITY,
  },
  deleteEntityTag: {
    name: 'deleteEntityTag',
    gql: DELETE_ENTITY_TAG,
  },
  createLoginMethod: {
    name: 'createLoginMethod',
    gql: CREATE_LOGIN_METHOD,
  },
  deleteLoginMethod: {
    name: 'deleteLoginMethod',
    gql: DELETE_LOGIN_METHOD,
  },
  acceptTermsAndConditions: {
    name: 'acceptTermsAndConditions',
    gql: ACCEPT_TERMS_AND_CONDITIONS,
  },
  createTermsAndConditions: {
    name: 'createTermsAndConditions',
    gql: CREATE_TERMS_AND_CONDITIONS,
  },
  activateTermsAndConditions: {
    name: 'activateTermsAndConditions',
    gql: ACTIVE_TERMS_AND_CONDITIONS,
  },
  updateImportantOperation: {
    name: 'updateImportantOperation',
    gql: UPDATE_IMPORTANT_OPERATION,
  },
  createInvitation: {
    name: 'createInvitation',
    gql: CREATE_INVITATION,
  },
  invitationResponse: {
    name: 'invitationResponse',
    gql: INVITATION_RESPONSE,
  },
  deleteInvitation: {
    name: 'deleteInvitation',
    gql: DELETE_INVITATION,
  },
  resendInvitation: {
    name: 'resendInvitation',
    gql: RESEND_INVITATION,
  },
  updateLastTenantIdSelected: {
    name: 'updateLastTenantIdSelected',
    gql: UPDATE_LAST_TENANT_ID_SELECTED,
  },
  updateTenantSettingValue: {
    name: 'updateTenantSettingValue',
    gql: UPDATE_TENANT_SETTING,
  },
  createTenantSettingValue: {
    name: 'createTenantSettingValue',
    gql: CREATE_TENANT_SETTING,
  },
  createCategory: {
    name: 'createCategory',
    gql: CREATE_CATEGORY,
  },
  updateCategory: {
    name: 'updateCategory',
    gql: UPDATE_CATEGORY,
  },
  deleteCategory: {
    name: 'deleteCategory',
    gql: DELETE_CATEGORY,
  },
  createProduct: {
    name: 'createProduct',
    gql: CREATE_PRODUCT,
  },
  updateProduct: {
    name: 'updateProduct',
    gql: UPDATE_PRODUCT,
  },
  deleteProduct: {
    name: 'deleteProduct',
    gql: DELETE_PRODUCT,
  },
  createStockMovement: {
    name: 'createStockMovement',
    gql: CREATE_STOCK_MOVEMENT,
  },
  forceChangePassword: {
    name: 'forceChangePassword',
    gql: FORCE_CHANGE_PASSWORD,
  },
  forceChangePasswordByAdmin: {
    name: 'forceChangePasswordByAdmin',
    gql: FORCE_CHANGE_PASSWORD_BY_ADMIN,
  },
  unlinkUser: {
    name: 'unlinkUser',
    gql: UNLINK_USER,
  },
  createShop: {
    name: 'createShop',
    gql: CREATE_SHOP,
  },
  updateShop: {
    name: 'updateShop',
    gql: UPDATE_SHOP,
  },
  deleteShop: {
    name: 'deleteShop',
    gql: DELETE_SHOP,
  },
  assignShopToTenant: {
    name: 'assignShopToTenant',
    gql: ASSIGN_SHOP_TO_TENANT,
  },
  deleteOrder: {
    name: 'deleteOrder',
    gql: DELETE_ORDER,
  },
  updateOrder: {
    name: 'updateOrder',
    gql: UPDATE_ORDER,
  },
  updateOrderShipmentAddress: {
    name: 'updateOrderShipmentAddress',
    gql: UPDATE_ORDER_SHIPMENT_ADDRESS,
  },
  updateOrderLine: {
    name: 'updateOrderLine',
    gql: UPDATE_ORDER_LINE,
  },
  deleteOrderLine: {
    name: 'deleteOrderLine',
    gql: DELETE_ORDER_LINE,
  },
  updateSupplier: {
    name: 'updateSupplier',
    gql: UPDATE_SUPPLIER,
  },
  updateOrderTotal: {
    name: 'updateOrderTotal',
    gql: UPDATE_ORDER_TOTAL,
  },
  rejectOrder: {
    name: 'rejectOrder',
    gql: REJECT_ORDER,
  },
  confirmOrder: {
    name: 'confirmOrder',
    gql: CONFIRM_ORDER,
  },
  registerPaymentOrder: {
    name: 'registerPaymentOrder',
    gql: REGISTER_PAYMENT_ORDER,
  },
  cancelOrder: {
    name: 'cancelOrder',
    gql: CANCEL_ORDER,
  },
  solicitRevisionOfOrder: {
    name: 'solicitRevisionOfOrder',
    gql: SOLICIT_REVISION_OF_ORDER,
  },
  registerDispatchOrder: {
    name: 'registerDispatchOrder',
    gql: REGISTER_DISPATCH_ORDER,
  },
  labelDelivered: {
    name: 'labelDelivered',
    gql: LABEL_DELIVERED,
  },
  labelReturned: {
    name: 'labelReturned',
    gql: LABEL_RETURNED,
  },
  generateTrackingCodeOrder: {
    name: 'generateTrackingCodeOrder',
    gql: GENERATE_TRACKING_CODE,
  },
  generateTicketOrder: {
    name: 'generateTicketOrder',
    gql: GENERATE_TICKET,
  },
  cancelTrackingCodeOrder: {
    name: 'cancelTrackingCodeOrder',
    gql: CANCEL_TRACKING_CODE,
  },
  deleteTicketOrder: {
    name: 'deleteTicketOrder',
    gql: DELETE_TICKET,
  },
  printTicketOrder: {
    name: 'printTicketOrder',
    gql: PRINT_TICKET_ORDER,
  },
  createWalletMovement: {
    name: 'createWalletMovement',
    gql: CREATE_WALLET_MOVEMENT,
  },
  registerOrderIncident: {
    name: 'registerOrderIncident',
    gql: REGISTER_ORDER_INCIDENT,
  },
  importOrderPayments: {
    name: 'importOrderPayments',
    gql: IMPORT_ORDER_PAYMENTS,
  },
  rescueOrder: {
    name: 'rescueOrder',
    gql: RESCUE_ORDER,
  },
  closeRevision: {
    name: 'closeRevision',
    gql: CLOSE_REVISION,
  },
  requestCancellation: {
    name: 'requestCancellation',
    gql: REQUEST_CANCELLATION,
  },
  closeIncident: {
    name: 'closeIncident',
    gql: CLOSE_INCIDENT,
  },
  createSupplier: {
    name: 'createSupplier',
    gql: CREATE_SUPPLIER,
  },
  deleteSupplier: {
    name: 'deleteSupplier',
    gql: DELETE_SUPPLIER,
  },
  prepareOrder: {
    name: 'prepareOrder',
    gql: PREPARE_ORDER,
  },
  dispatchScannedOrder: {
    name: 'dispatchScannedOrder',
    gql: DISPATCH_SCANNED_ORDER,
  },
  returnStockOrder: {
    name: 'returnStockOrder',
    gql: RETURN_STOCK_ORDER,
  },
  createTenantPublic: {
    name: 'createTenantPublic',
    gql: CREATE_TENANT_PUBLIC,
  },
  createWalletRequest: {
    name: 'createWalletRequest',
    gql: CREATE_WALLET_REQUEST,
  },
  deleteWalletRequest: {
    name: 'deleteWalletRequest',
    gql: DELETE_WALLET_REQUEST,
  },
  updateWalletRequest: {
    name: 'updateWalletRequest',
    gql: UPDATE_WALLET_REQUEST,
  },
  resendEmailCreatePublic: {
    name: 'resendEmailCreatePublic',
    gql: RESEND_EMAIL_CREATE_PUBLIC,
  },
  addOrderLine: {
    name: 'addOrderLine',
    gql: ADD_ORDER_LINE,
  },
  updateOrderPaymentStatus: {
    name: 'updateOrderPaymentStatus',
    gql: UPDATE_ORDER_PAYMENT_STATUS,
  },
  updateOrderPaymentType: {
    name: 'updateOrderPaymentType',
    gql: UPDATE_ORDER_PAYMENT_TYPE,
  },
  updateNotificationStatus: {
    name: 'updateNotificationStatus',
    gql: UPDATE_NOTIFICATION_STATUS,
  },
  solicitAdjustmentsOfProduct: {
    name: 'solicitAdjustmentsOfProduct',
    gql: SOLICIT_ADJUSTMENTS_OF_PRODUCT,
  },
  solicitRevisionOfProduct: {
    name: 'solicitRevisionOfProduct',
    gql: SOLICIT_REVISION_OF_PRODUCT,
  },
  solicitApprovalOfProduct: {
    name: 'solicitApprovalOfProduct',
    gql: SOLICIT_APPROVAL_OF_PRODUCT,
  },
  solicitRejectOfProduct: {
    name: 'solicitRejectOfProduct',
    gql: SOLICIT_REJECT_OF_PRODUCT,
  },
  toggleProductStatus: {
    name: 'toggleProductStatus',
    gql: TOGGLE_PRODUCT_STATUS,
  },
  toggleProductSpecificationStatus: {
    name: 'toggleProductSpecificationStatus',
    gql: TOGGLE_PRODUCT_SPECIFICATION_STATUS,
  },
  createProgram: {
    name: 'createProgram',
    gql: CREATE_PROGRAM,
  },
  updateProgram: {
    name: 'updateProgram',
    gql: UPDATE_PROGRAM,
  },
  deleteProgram: {
    name: 'deleteProgram',
    gql: DELETE_PROGRAM,
  },
  createProgramPricing: {
    name: 'createProgramPricing',
    gql: CREATE_PROGRAM_PRICING,
  },
  updateProgramPrices: {
    name: 'updateProgramPrices',
    gql: UPDATE_PROGRAM_PRICES,
  },
  createProgramCategory: {
    name: 'createProgramCategory',
    gql: CREATE_PROGRAM_CATEGORY,
  },
  updateProgramCategory: {
    name: 'updateProgramCategory',
    gql: UPDATE_PROGRAM_CATEGORY,
  },
  deleteProgramCategory: {
    name: 'deleteProgramCategory',
    gql: DELETE_PROGRAM_CATEGORY,
  },
  createProgramRegion: {
    name: 'createProgramRegion',
    gql: CREATE_PROGRAM_REGION,
  },
  updateProgramRegion: {
    name: 'updateProgramRegion',
    gql: UPDATE_PROGRAM_REGION,
  },
  deleteProgramRegion: {
    name: 'deleteProgramRegion',
    gql: DELETE_PROGRAM_REGION,
  },
  createEvent: {
    name: 'createEvent',
    gql: CREATE_EVENT,
  },
  updateEvent: {
    name: 'updateEvent',
    gql: UPDATE_EVENT,
  },
  deleteEvent: {
    name: 'deleteEvent',
    gql: DELETE_EVENT,
  },
  createVcg: {
    name: 'createVcg',
    gql: CREATE_VCG,
  },
  updateVcg: {
    name: 'updateVcg',
    gql: UPDATE_VCG,
  },
  deleteVcg: {
    name: 'deleteVcg',
    gql: DELETE_VCG,
  },
  createUsaProgram: {
    name: 'createUsaProgram',
    gql: CREATE_USA_PROGRAM,
  },
  updateUsaProgram: {
    name: 'updateUsaProgram',
    gql: UPDATE_USA_PROGRAM,
  },
  deleteUsaProgram: {
    name: 'deleteUsaProgram',
    gql: DELETE_USA_PROGRAM,
  },
  createProgramVariant: {
    name: 'createProgramVariant',
    gql: CREATE_PROGRAM_VARIANT,
  },
  updateProgramVariant: {
    name: 'updateProgramVariant',
    gql: UPDATE_PROGRAM_VARIANT,
  },
  deleteProgramVariant: {
    name: 'deleteProgramVariant',
    gql: DELETE_PROGRAM_VARIANT,
  },
  createExhibitionCategory: {
    name: 'createExhibitionCategory',
    gql: CREATE_EXHIBITION_CATEGORY,
  },
  updateExhibitionCategory: {
    name: 'updateExhibitionCategory',
    gql: UPDATE_EXHIBITION_CATEGORY,
  },
  deleteExhibitionCategory: {
    name: 'deleteExhibitionCategory',
    gql: DELETE_EXHIBITION_CATEGORY,
  },
  createExhibitionSubcategory: {
    name: 'createExhibitionSubcategory',
    gql: CREATE_EXHIBITION_SUBCATEGORY,
  },
  updateExhibitionSubcategory: {
    name: 'updateExhibitionSubcategory',
    gql: UPDATE_EXHIBITION_SUBCATEGORY,
  },
  deleteExhibitionSubcategory: {
    name: 'deleteExhibitionSubcategory',
    gql: DELETE_EXHIBITION_SUBCATEGORY,
  },
  createTaxCondition: {
    name: 'createTaxCondition',
    gql: CREATE_TAX_CONDITION,
  },
  updateTaxCondition: {
    name: 'updateTaxCondition',
    gql: UPDATE_TAX_CONDITION,
  },
  deleteTaxCondition: {
    name: 'deleteTaxCondition',
    gql: DELETE_TAX_CONDITION,
  },
  createHitoTipo: {
    name: 'createHitoTipo',
    gql: CREATE_HITO_TIPO,
  },
  updateHitoTipo: {
    name: 'updateHitoTipo',
    gql: UPDATE_HITO_TIPO,
  },
  deleteHitoTipo: {
    name: 'deleteHitoTipo',
    gql: DELETE_HITO_TIPO,
  },
  createHitoSubtipo: {
    name: 'createHitoSubtipo',
    gql: CREATE_HITO_SUBTIPO,
  },
  updateHitoSubtipo: {
    name: 'updateHitoSubtipo',
    gql: UPDATE_HITO_SUBTIPO,
  },
  deleteHitoSubtipo: {
    name: 'deleteHitoSubtipo',
    gql: DELETE_HITO_SUBTIPO,
  },
  createMemberHito: {
    name: 'createMemberHito',
    gql: CREATE_MEMBER_HITO,
  },
  updateMemberHito: {
    name: 'updateMemberHito',
    gql: UPDATE_MEMBER_HITO,
  },
  deleteMemberHito: {
    name: 'deleteMemberHito',
    gql: DELETE_MEMBER_HITO,
  },
  createContact: {
    name: 'createContact',
    gql: CREATE_CONTACT,
  },
  updateContact: {
    name: 'updateContact',
    gql: UPDATE_CONTACT,
  },
  deleteContact: {
    name: 'deleteContact',
    gql: DELETE_CONTACT,
  },
  createStaff: {
    name: 'createStaff',
    gql: CREATE_STAFF,
  },
  updateStaff: {
    name: 'updateStaff',
    gql: UPDATE_STAFF,
  },
  deleteStaff: {
    name: 'deleteStaff',
    gql: DELETE_STAFF,
  },
  createChair: {
    name: 'createChair',
    gql: CREATE_CHAIR,
  },
  updateChair: {
    name: 'updateChair',
    gql: UPDATE_CHAIR,
  },
  deleteChair: {
    name: 'deleteChair',
    gql: DELETE_CHAIR,
  },
  createProspect: {
    name: 'createProspect',
    gql: CREATE_PROSPECT,
  },
  createProspectWithContact: {
    name: 'createProspectWithContact',
    gql: CREATE_PROSPECT_WITH_CONTACT,
  },
  updateProspect: {
    name: 'updateProspect',
    gql: UPDATE_PROSPECT,
  },
  deleteProspect: {
    name: 'deleteProspect',
    gql: DELETE_PROSPECT,
  },
  requestProspectReassignment: {
    name: 'requestProspectReassignment',
    gql: REQUEST_PROSPECT_REASSIGNMENT,
  },
  approveProspectReassignmentAsChair: {
    name: 'approveProspectReassignmentAsChair',
    gql: APPROVE_PROSPECT_REASSIGNMENT_AS_CHAIR,
  },
  approveProspectReassignmentAsStaff: {
    name: 'approveProspectReassignmentAsStaff',
    gql: APPROVE_PROSPECT_REASSIGNMENT_AS_STAFF,
  },
  rejectProspectReassignment: {
    name: 'rejectProspectReassignment',
    gql: REJECT_PROSPECT_REASSIGNMENT,
  },
  createGroup: {
    name: 'createGroup',
    gql: CREATE_GROUP,
  },
  updateGroup: {
    name: 'updateGroup',
    gql: UPDATE_GROUP,
  },
  deleteGroup: {
    name: 'deleteGroup',
    gql: DELETE_GROUP,
  },
  assignChairToGroup: {
    name: 'assignChairToGroup',
    gql: ASSIGN_CHAIR_TO_GROUP,
  },
  updateGroupChairAssignment: {
    name: 'updateGroupChairAssignment',
    gql: UPDATE_GROUP_CHAIR_ASSIGNMENT,
  },
  updateAllGroupsBudget: {
    name: 'updateAllGroupsBudget',
    gql: UPDATE_ALL_GROUPS_BUDGET,
  },
  createExhibitor: {
    name: 'createExhibitor',
    gql: CREATE_EXHIBITOR,
  },
  updateExhibitor: {
    name: 'updateExhibitor',
    gql: UPDATE_EXHIBITOR,
  },
  updateMyExhibitorProfile: { name: 'updateMyExhibitorProfile', gql: UPDATE_MY_EXHIBITOR_PROFILE },
  deleteExhibitor: {
    name: 'deleteExhibitor',
    gql: DELETE_EXHIBITOR,
  },
  createExhibitorReview: {
    name: 'createExhibitorReview',
    gql: CREATE_EXHIBITOR_REVIEW,
  },
  inviteExhibitorByForm: {
    name: 'inviteExhibitorByForm',
    gql: INVITE_EXHIBITOR_BY_FORM,
  },
  submitExhibitorForm: {
    name: 'submitExhibitorForm',
    gql: SUBMIT_EXHIBITOR_FORM,
  },
  uploadExhibitorFormProfilePicture: {
    name: 'uploadExhibitorFormProfilePicture',
    gql: UPLOAD_EXHIBITOR_FORM_PROFILE_PICTURE,
  },
  updateExternalPresenterInvoiceData: {
    name: 'updateExternalPresenterInvoiceData',
    gql: UPDATE_EXTERNAL_PRESENTER_INVOICE_DATA,
  },
  submitExternalPresenterInvoiceByToken: {
    name: 'submitExternalPresenterInvoiceByToken',
    gql: SUBMIT_EXTERNAL_PRESENTER_INVOICE_BY_TOKEN,
  },
  resendExternalPresenterInvoiceToken: {
    name: 'resendExternalPresenterInvoiceToken',
    gql: RESEND_EXTERNAL_PRESENTER_INVOICE_TOKEN,
  },
  createMember: {
    name: 'createMember',
    gql: CREATE_MEMBER,
  },
  updateMember: {
    name: 'updateMember',
    gql: UPDATE_MEMBER,
  },
  deleteMember: {
    name: 'deleteMember',
    gql: DELETE_MEMBER,
  },
  addMemberToHumand: {
    name: 'addMemberToHumand',
    gql: ADD_MEMBER_TO_HUMAND,
  },
  createFollowUpNote: {
    name: 'createFollowUpNote',
    gql: CREATE_FOLLOW_UP_NOTE,
  },
  createContactFollowUpNote: {
    name: 'createContactFollowUpNote',
    gql: CREATE_CONTACT_FOLLOW_UP_NOTE,
  },
  createEntryForm: {
    name: 'createEntryForm',
    gql: CREATE_ENTRY_FORM,
  },
  editEntryForm: {
    name: 'editEntryForm',
    gql: EDIT_ENTRY_FORM,
  },
  deleteEntryForm: {
    name: 'deleteEntryForm',
    gql: DELETE_ENTRY_FORM,
  },
  requestEntryForms: {
    name: 'requestEntryForms',
    gql: REQUEST_ENTRY_FORMS,
  },
  cancelEntryForms: {
    name: 'cancelEntryForms',
    gql: CANCEL_ENTRY_FORMS,
  },
  approveEntryForm: {
    name: 'approveEntryForm',
    gql: APPROVE_ENTRY_FORM,
  },
  finalizeEntryForm: {
    name: 'finalizeEntryForm',
    gql: FINALIZE_ENTRY_FORM,
  },
  loadEntryForm: {
    name: 'loadEntryForm',
    gql: LOAD_ENTRY_FORM,
  },
  confirmEntryForm: {
    name: 'confirmEntryForm',
    gql: CONFIRM_ENTRY_FORM,
  },
  markProcessedEntryForm: {
    name: 'markProcessedEntryForm',
    gql: MARK_PROCESSED_ENTRY_FORM,
  },
  changeEntryFormStatus: {
    name: 'changeEntryFormStatus',
    gql: CHANGE_ENTRY_FORM_STATUS,
  },
  uploadEntryFormSignature: {
    name: 'uploadEntryFormSignature',
    gql: UPLOAD_ENTRY_FORM_SIGNATURE,
  },
  uploadEntryFormAuthorization: {
    name: 'uploadEntryFormAuthorization',
    gql: UPLOAD_ENTRY_FORM_AUTHORIZATION,
  },
  saveEntryFormDraft: {
    name: 'saveEntryFormDraft',
    gql: SAVE_ENTRY_FORM_DRAFT,
  },
  submitEntryForm: {
    name: 'submitEntryForm',
    gql: SUBMIT_ENTRY_FORM,
  },
  uploadEntryFormSignatureByToken: {
    name: 'uploadEntryFormSignatureByToken',
    gql: UPLOAD_ENTRY_FORM_SIGNATURE_BY_TOKEN,
  },
  createMeeting: {
    name: 'createMeeting',
    gql: MEETING.CREATE_MEETING,
  },
  updateMeeting: {
    name: 'updateMeeting',
    gql: MEETING.UPDATE_MEETING,
  },
  deleteMeeting: {
    name: 'deleteMeeting',
    gql: MEETING.DELETE_MEETING,
  },
  updateMeetingMember: {
    name: 'updateMeetingMember',
    gql: MEETING.UPDATE_MEETING_MEMBER,
  },
  finalizeMeetingAndSendEvaluations: {
    name: 'finalizeMeetingAndSendEvaluations',
    gql: MEETING.FINALIZE_MEETING_AND_SEND_EVALUATIONS,
  },
  generateEvaluationLinks: {
    name: 'generateEvaluationLinks',
    gql: MEETING.GENERATE_EVALUATION_LINKS,
  },
  createMeetingGroup: {
    name: 'createMeetingGroup',
    gql: CREATE_MEETING_GROUP,
  },
  createMeetingGroups: {
    name: 'createMeetingGroups',
    gql: CREATE_MEETING_GROUPS,
  },
  removeMeetingGroup: {
    name: 'removeMeetingGroup',
    gql: REMOVE_MEETING_GROUP,
  },
  completeMeetingGroups: {
    name: 'completeMeetingGroups',
    gql: COMPLETE_MEETING_GROUPS,
  },
  markAttendanceLoaded: {
    name: 'markAttendanceLoaded',
    gql: MARK_ATTENDANCE_LOADED,
  },
  resendEvaluationEmail: {
    name: 'resendEvaluationEmail',
    gql: RESEND_EVALUATION_EMAIL,
  },
  updateMeetingMemberEvaluation: {
    name: 'updateMeetingMemberEvaluation',
    gql: MEETING.UPDATE_MEETING_MEMBER_EVALUATION,
  },
  submitEvaluation: {
    name: 'submitEvaluation',
    gql: SUBMIT_EVALUATION,
  },
  submitMeetingEvaluation: {
    name: 'submitMeetingEvaluation',
    gql: SUBMIT_MEETING_EVALUATION,
  },
  createRequest: {
    name: 'createRequest',
    gql: CREATE_REQUEST,
  },
  editPendingRequest: {
    name: 'editPendingRequest',
    gql: EDIT_PENDING_REQUEST,
  },
  approveRequest: {
    name: 'approveRequest',
    gql: APPROVE_REQUEST,
  },
  rejectRequest: {
    name: 'rejectRequest',
    gql: REJECT_REQUEST,
  },
  cancelRequest: {
    name: 'cancelRequest',
    gql: CANCEL_REQUEST,
  },
  logicDeleteRequest: {
    name: 'logicDeleteRequest',
    gql: LOGIC_DELETE_REQUEST,
  },
  finalizeRequest: {
    name: 'finalizeRequest',
    gql: FINALIZE_REQUEST,
  },
  createTopic: {
    name: 'createTopic',
    gql: CREATE_TOPIC,
  },
  updateTopic: {
    name: 'updateTopic',
    gql: UPDATE_TOPIC,
  },
  deleteTopic: {
    name: 'deleteTopic',
    gql: DELETE_TOPIC,
  },
  createPresentation: {
    name: 'createPresentation',
    gql: CREATE_PRESENTATION,
  },
  updatePresentation: {
    name: 'updatePresentation',
    gql: UPDATE_PRESENTATION,
  },
  deletePresentation: {
    name: 'deletePresentation',
    gql: DELETE_PRESENTATION,
  },
  submitPresentation: {
    name: 'submitPresentation',
    gql: SUBMIT_PRESENTATION,
  },
  cancelPresentation: {
    name: 'cancelPresentation',
    gql: CANCEL_PRESENTATION,
  },
  loadPresentationReceipts: {
    name: 'loadPresentationReceipts',
    gql: LOAD_PRESENTATION_RECEIPTS,
  },
  rollbackPresentationBilling: {
    name: 'rollbackPresentationBilling',
    gql: ROLLBACK_PRESENTATION_BILLING,
  },
  registerPresentationClose: {
    name: 'registerPresentationClose',
    gql: REGISTER_PRESENTATION_CLOSE,
  },
  uploadPresentationExpenseFile: {
    name: 'uploadPresentationExpenseFile',
    gql: UPLOAD_PRESENTATION_EXPENSE_FILE,
  },
  uploadPresentationInvoiceFile: {
    name: 'uploadPresentationInvoiceFile',
    gql: UPLOAD_PRESENTATION_INVOICE_FILE,
  },
  uploadPresentationViaticosFile: {
    name: 'uploadPresentationViaticosFile',
    gql: UPLOAD_PRESENTATION_VIATICOS_FILE,
  },
  sendPresentationInvoiceDocumentation: {
    name: 'sendPresentationInvoiceDocumentation',
    gql: SEND_PRESENTATION_INVOICE_DOCUMENTATION,
  },
  changePresentationStatus: {
    name: 'changePresentationStatus',
    gql: CHANGE_PRESENTATION_STATUS,
  },
  createLeaveForm: {
    name: 'createLeaveForm',
    gql: CREATE_LEAVE_FORM,
  },
  submitLeaveFormByToken: {
    name: 'submitLeaveFormByToken',
    gql: SUBMIT_LEAVE_FORM_BY_TOKEN,
  },
  createLeaveFormCallAttempt: {
    name: 'createLeaveFormCallAttempt',
    gql: CREATE_LEAVE_FORM_CALL_ATTEMPT,
  },
  applyGroupMovement: {
    name: 'applyGroupMovement',
    gql: APPLY_GROUP_MOVEMENT,
  },
  reverseGroupMovement: {
    name: 'reverseGroupMovement',
    gql: REVERSE_GROUP_MOVEMENT,
  },
  uploadGroupFiles: {
    name: 'uploadGroupFiles',
    gql: UPLOAD_GROUP_FILES,
  },
  deleteGroupFile: {
    name: 'deleteGroupFile',
    gql: DELETE_GROUP_FILE,
  },
  createSurveyCampaign: {
    name: 'createSurveyCampaign',
    gql: CREATE_SURVEY_CAMPAIGN,
  },
  sendSurveyCampaign: {
    name: 'sendSurveyCampaign',
    gql: SEND_SURVEY_CAMPAIGN,
  },
  scheduleSurveyCampaign: {
    name: 'scheduleSurveyCampaign',
    gql: SCHEDULE_SURVEY_CAMPAIGN,
  },
  sendSurveyCampaignTest: {
    name: 'sendSurveyCampaignTest',
    gql: SEND_SURVEY_CAMPAIGN_TEST,
  },
  updateSurveyCampaign: {
    name: 'updateSurveyCampaign',
    gql: UPDATE_SURVEY_CAMPAIGN,
  },
  resendSurveyCampaign: {
    name: 'resendSurveyCampaign',
    gql: RESEND_SURVEY_CAMPAIGN,
  },
  cancelSurveyCampaign: {
    name: 'cancelSurveyCampaign',
    gql: CANCEL_SURVEY_CAMPAIGN,
  },
  registerBudgetMovement: {
    name: 'registerBudgetMovement',
    gql: REGISTER_BUDGET_MOVEMENT,
  },
};

export { Mutation };
export * from './ProgramVariant';
